<template>
  <div id="room-section" class="py-1 px-3 border-b border-slate-400">
    <div
      class="flex items-center justify-between px-3 py-2 mb-1 cursor-pointer"
      @click="chevronOpened = !chevronOpened"
      :title="title"
    >
      <BlTextSubtitle3 :text="title" class="text-slate-600 truncate" />
      <div class="flex items-center gap-2">
        <BlBubbleCount :count="rooms.length || 0" />
        <BlIcon
          icon="chevron-up"
          class="w-4 h-4 transition-all duration-300"
          :style="chevronOpened ? { rotate: '0deg' } : { rotate: '180deg' }"
        />
      </div>
    </div>
    <div v-if="chevronOpened" class="flex flex-col gap-1">
      <div
        v-if="title === 'No branch' && currentUser.role.includes('admin')"
        class="py-2 px-4 rounded bg-cornflower-200"
      >
        <BlTextBody2
          text="New branch needed? Create it in"
          class="text-cornflower-800 flex-wrap"
        />
        <router-link
          to="/repository?tab=branch"
          target="_blank"
          class="flex items-center gap-1"
        >
          <BlTextBody2
            text="Repository."
            class="text-cornflower-800 flex-wrap font-bold underline"
          />
          <BlIcon icon="square-up" color="cornflower-8" class="h-4 w-4" />
        </router-link>
      </div>
      <RoomItem
        v-for="room in rooms"
        :key="room.id"
        :room="room"
        :isActive="selectedRoomId === room.id"
        @change-select="$emit('select-room', $event)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RoomItem from "./Item.vue";

import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlBubbleCount from "../../BlBubbleCount.vue";
import BlIcon from "../../BlIcon.vue";

export default {
  name: "RoomGroupBranch",
  components: {
    RoomItem,
    BlTextSubtitle3,
    BlTextBody2,
    BlBubbleCount,
    BlIcon
  },
  props: {
    title: { type: String, required: true },
    rooms: { required: true },
    selectedRoomId: { default: 0 }
    // $emit('select-room')
  },
  data() {
    return {
      chevronOpened: true
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/availabilities/room/GroupBranch.vue